// extracted by mini-css-extract-plugin
module.exports = {"bgc":"index-bgc-3VFr8","teamXcxRoot":"index-teamXcxRoot-2M0RG","closeBtn":"index-closeBtn-1Almn"};